export interface IDashPwlLabBilling {
    id:number 
    entrySource: string, 
    organType: string,
    registrationId: number,
    uploadDateTime:string, 
    requisitionNumber:string, 
    isBillable: boolean,
    centerId: number,
    registrationFullName: string,
    registrationDob: string 
    phlebot: boolean
}